import { Swiper, SwiperSlide } from "swiper/react";
import { twMerge } from "tailwind-merge";
import AppButton from "../../Common/AppButton";
import { ReactComponent as LockSvg } from '../../../assets/icons/lock.svg';
import { ReactComponent as UnlockSvg } from '../../../assets/icons/lock_open_right.svg';
import { useAuth } from "../../../providers/auth-provider";
import { PREMIER_1TOURNAMENT_PLAN, SUPER_1TOURNAMENT_PLAN, getDateStringForTournament, getDateStringFromFinalTournament, getDatefromFirebaseTimeStamp, getTournamentDaysToGo } from "../../../Constants/Commons";
import { useNavigate, useSearchParams } from "react-router-dom";
import mixpanel from 'mixpanel-browser';
import { useState } from "react";

const PracticeTournamentCarousel = ({ tournaments }) => {
  const navigate = useNavigate();
  const [searchParams, _] = useSearchParams();
  const isDemo = searchParams.get("d") === "S";
  const [activeSlide, setActiveSlide] = useState(tournaments[0]);
  const { user } = useAuth();

  const handleNavigateToTournament = () => {

    mixpanel.identify(user.id);
    mixpanel.track('completed_tournamentPlay', {
      tournamentId: activeSlide.id,
    });

    if (!activeSlide.isLocked) {
      navigate(`/completed-tournament-practice?tid=${activeSlide.id}`);
    };
  }

  const renderCTA = (
    isLocked,
    isDarkBanner,
    tId,
  ) => {
    const goToCheckout = (id, tId) => {
      let url = `/checkout?planId=${id}&tId=${tId}&back=/completed-tournament-practice-lobby`;
      navigate(url);
      //navigate(`/checkout?planId=${id}&tId=${tId}`);
    };
    const handleOnClick = () => {
      if (isLocked) {
        goToCheckout(`TOURNAMENTS_1`, tId);
      }
      else {

      }
    }

    return (
      <AppButton
        className={twMerge(
          "h-6 rounded-[6px] text-[12px] px-2 absolute bottom-5 left-0 ",
          !isDarkBanner && "bg-primary-gray-20 text-primary-yellow"
        )}

        onClick={() => handleOnClick()}
      >
        {isLocked ? "Unlock" : "Play Now"}
      </AppButton>
    );
  }


  return (
    <Swiper
      spaceBetween={0}
      slidesPerView={1.2}
      className="h-44 md:h-56"
      scrollbar={{ draggable: true, horizontalClass: "!bg-[#3a3a3a]" }}
      breakpoints={{
        768: {
          slidesPerView: 1.7, // Show 2 slides on screens wider than or equal to 768px
        },
      }}
      onSlideChange={(swiper) => {
        setActiveSlide(tournaments[swiper.realIndex]);
      }}
    >
      {tournaments.map((banner, index) => {
        const {
          newLobbyTournamentBanner,
          isDarkBanner,
          name,
          topics,
          tournamentNumber,
          id,
          isLocked,
        } = banner;
        const topicString = topics.join(", ");

        let dateString = "";
        const startDate = getDatefromFirebaseTimeStamp(banner.startDate);
        const endDate = getDatefromFirebaseTimeStamp(banner.endDate);

        if (startDate && endDate) {
          dateString = getDateStringFromFinalTournament(startDate, endDate);
        }
        return (
          <SwiperSlide key={index} className="pl-4">
            <div
              className={twMerge(
                "rounded-lg bg-cover bg-center h-40 md:h-52  w-full px-4 grid grid-cols-7 items-center relative overflow-hidden",
                isDarkBanner ? "text-white" : "text-black"
              )}
              style={{
                backgroundImage: `url(${newLobbyTournamentBanner})`,
              }}
              onClick={handleNavigateToTournament}
            >
              {isLocked && <div
                className={twMerge(
                  "absolute top-0 left-0 h-6 w-9 md:h-8 md:w-11 rounded-br-lg grid place-items-center shadow-[0_4px_4px_rgba(0,0,0,0.25)]",
                  isLocked ? "bg-[#c32230]" : "bg-primary-yellow"
                )}
              >
                <LockSvg className="h-[14px] w-[14px] md:w-5 md:h-5" />
              </div>
              }
              <div className="col-span-4 mt-4 flex flex-col h-full justify-between pb-5 md:pt-10 pt-7 relative">
                <div>
                  <div className="text-lg md:text-xl leading-[1]">{name}</div>
                  <div
                    className={twMerge(
                      "text-[10px] md:text-sm",
                      !isDarkBanner && "text-primary-gray-10 mt-1"
                    )}
                  >
                    {topicString}
                  </div>
                  <div
                    className={twMerge(
                      "mt-2 text-xs md:text-base",
                      !isDarkBanner && "text-primary-gray-10"
                    )}
                  >
                    {dateString}
                  </div>
                  {renderCTA(isLocked, isDarkBanner, id)}

                </div>

              </div>
            </div>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};

export default PracticeTournamentCarousel;